import { TextField } from '@mui/material'
import React, { Fragment } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Paper, Typography } from '@mui/material';
import { actualizaDomiciliosCliente } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Avatar from '@mui/material/Avatar';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import moment from 'moment'
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from './ModalHistorialCambiosComponent';

function DomiciliosComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const [editar, setEditar] = React.useState(false)

    const [calle, setCalle] = React.useState(props?.data?.calle?.toUpperCase())
    const [numerointerior, setNumeroInterior] = React.useState((props?.data?.numerointerior == '' || props?.data?.numerointerior == undefined || props?.data?.numerointerior == null) ? 'S/N' : props?.data?.numerointerior?.toUpperCase())
    const [numeroexterior, setNumeroExterior] = React.useState((props?.data?.numeroexterior == '' || props?.data?.numeroexterior == undefined || props?.data?.numerointerior == null) ? 'S/N' : props?.data?.numeroexterior?.toUpperCase())
    const [colonia, setColonia] = React.useState(props?.data?.colonia?.toUpperCase())
    const [localidad, setLocalidad] = React.useState(props?.data?.localidad?.toUpperCase())
    const [municipioalcaldia, setMunicipioAlcaldia] = React.useState(props?.data?.municipioalcaldia?.toUpperCase())
    const [estado, setEstado] = React.useState(props?.data?.estado?.toUpperCase())
    const [codigopostal, setCodigoPostal] = React.useState(props?.data?.codigopostal?.toUpperCase())

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.domiciliofiscalclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.domiciliofiscalclientehistorial)
        setOpenModalHistorial(true)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 250,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
                            <h3 className='text-center'><b>ADVERTENCIA</b></h3>
                            <p className='mt-3'>¿Está seguro que desea actualizar el domicilio seleccionado?</p>
                        </Typography>
                        <br />
                        <ThemeProvider theme={theme}>
                            <div className='row'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }
    const btnContinuar = async () => {
        const fechaHoy = moment().format('YYYY-MM-DD')

        await dispatch(actualizarLoadingApp_true())
        let fechainscripcion = new Date(fechaHoy).toISOString()

        let dataActualizar = {
            datacambio: {
                calle: calle, numerointerior: numerointerior, numeroexterior: numeroexterior, colonia: colonia, localidad: localidad,
                municipioalcaldia: municipioalcaldia, estado: estado, codigopostal: codigopostal, iddomiciliofiscal: props?.data?.iddomiciliofiscal
            },
            iddomiciliofiscal: props?.data?.iddomiciliofiscal, usuariocambio: dataUser?.[0]?.usuario, fechacambio: fechainscripcion
        }
        await dispatch(actualizaDomiciliosCliente(dataActualizar))
        handleCloseModal()
        setEditar(false)
        props?.setIsEdicionDomicilio(true)
        await dispatch(actualizarLoadingApp_false())
    }

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                        <Avatar sx={props?.data.isbaja ? { bgcolor: '#DC3545', width: '9%' } : { bgcolor: '#8ABE3E', width: '9%' }} variant="square"> {props?.data?.domicilioprincipal ?
                            <a href={`https://www.google.com/maps/search/${calle}, ${numeroexterior}, ${colonia}, ${localidad}, ${municipioalcaldia}, ${estado}`} target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>F</a> :
                            <a href={`https://www.google.com/maps/search/${calle}, ${numeroexterior}, ${colonia}, ${localidad}, ${municipioalcaldia}, ${estado}`} target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>S</a>}
                        </Avatar>

                        {/*<Typography sx={{ color: 'text.secondary', width: '15%' }}>{props?.data?.domicilioprincipal ? 'Principal' : 'Sucursal'}</Typography>*/}
                        <Typography sx={{ width: '91%', flexShrink: 0, display: 'flex', alignItems: 'center', paddingLeft: '3%' }}>  {calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' + colonia + ', ' + localidad + ', ' + municipioalcaldia + ', ' + estado + ', ' + codigopostal} </Typography>
                        {/*<Typography sx={{ color: 'text.secondary', width: '15%' }}>{props?.data.isbaja ? 'Inactiva' : 'Activa'}</Typography>*/}
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='row'>
                            {!editar &&
                                <div className='row' style={{ margin: 0, padding: 0 }}>
                                    {props?.data?.isbaja == false &&
                                        <div style={{ display: 'flex', justifyContent: 'end' }} >
                                            <Tooltip title="Ver historial de cambios">
                                                <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                    <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                    }                                    
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Calle: <br /> </b> {calle} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número Interior: <br /> </b> {numerointerior} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número Exterior: <br /> </b> {numeroexterior} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Colonia: <br /> </b> {colonia} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Localidad: <br /> </b> {localidad} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Municipio: <br /> </b> {municipioalcaldia} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Estado: <br /> </b> {estado} </label> </div>
                                    <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Código postal: <br /> </b> {codigopostal} </label> </div>
                                </div>
                            }
                            {editar &&
                                <div className='row' style={{ margin: 0, padding: 0 }}>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Calle" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={calle} onChange={e => setCalle(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Número Interior" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={numerointerior} onChange={e => setNumeroInterior(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Número Exterior" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={numeroexterior} onChange={e => setNumeroExterior(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Colonia" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={colonia} onChange={e => setColonia(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Localidad" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={localidad} onChange={e => setLocalidad(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Municipio" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={municipioalcaldia} onChange={e => setMunicipioAlcaldia(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Estado" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={estado} onChange={e => setEstado(e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-6 pe-5 ps-3'>
                                        <TextField id="standard-basic" label="Codigo Postal" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                            value={codigopostal} onChange={e => setCodigoPostal(e.target.value?.toUpperCase())} />
                                    </div>
                                </div>
                            }
                            {!props?.data?.isbaja && !editar && dataUser?.[0]?.idrol == 1 && 
                                <ThemeProvider theme={theme}>
                                    <div className='col-md-12 mt-4 mb-5 justify-content-center'>
                                        <Button variant="contained" color="primary" style={{ width: '50%' }} onClick={() => setEditar(true)}>Editar domicilio</Button>
                                    </div>
                                </ThemeProvider>
                            }
                            {editar &&
                                <div className='row mt-4 mb-5'>
                                    <div className='col-6 col-md-6 justify-content-center'>
                                        <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                                    </div>
                                    <div className='col-6 col-md-6 justify-content-center'>
                                        <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                                    </div>
                                </div>
                            }

                        </div>
                    </AccordionDetails>
                </Accordion>
            </ThemeProvider>
            {modalComponent()}
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Domicilio"} />}
        </Fragment >
    )
}

export default DomiciliosComponent